<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Plan</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Plan form</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Product">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info"
                             :to="{name: 'SubscriptionPlanList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="form-row">
                  <div class="form-group col-6 required">
                    <label class="control-label">Ref-Id</label>
                    <br/>
                    <el-select v-model="value.ref_id" v-validate="'required'"
                               name="ref_id" placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in allUniqueRefIds"
                        :key="index"
                        v-bind:class="{
                        'has-error': errors.has('ref_id'),
                      }"
                        v-validate="'required'"
                        :label="item"
                        :value="index"
                      >
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('ref_id')">
                      {{ errors.first('ref_id') }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label">Name</label>
                    <input type="text" id="name" name="name" v-bind:class="{'has-error' : errors.has('name')}"
                           v-validate="'required'" v-model="value.name" class="form-control name"
                           placeholder="Name">
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label">Product</label>
                    <el-select v-model="value.product_id" v-validate="'required'" name="product_id"
                               filterable clearable placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in allProducts" :key="item.id"
                        v-bind:class="{'has-error': errors.has('product_id')}"
                        v-validate="'required'" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('product_id')">
                      {{ errors.first("product_id") }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label" for="group_name">Group</label>
                    <input type="text" id="group_name" name="group_name"
                           v-bind:class="{'has-error' : errors.has('group_name')}"
                           v-validate="'required'" v-model="value.group_name" class="form-control group_name"
                           placeholder="group">
                    <div class="help text-danger" v-show="errors.has('group_name')">
                      {{ errors.first("group_name") }}
                    </div>
                  </div>
                  <!--<div class="form-group col-6">
                    <label class="control-label">Base Subscription Plan</label>
                    <el-select v-model="value.base_subscription_plan_id"
                               name="base_subscription_plan_id"
                               placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in allSubscriptionPlans" :key="index"
                        v-bind:class="{'has-error': errors.has('base_subscription_plan_id')}"
                        v-validate="'required'" :label="item" :value="index">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('base_subscription_plan_id')">
                      {{ errors.first("base_subscription_plan_id") }}
                    </div>
                  </div>-->

                  <div class="form-group col-6 required">
                    <label class="control-label">Phase</label>
                    <el-select v-model="value.phase" v-validate="'required'" name="phase"
                               style="width: 100%" placeholder="select published phase">
                      <el-option
                        v-for="item in [{value: 'Initial', label: 'Initial'}, {value: 'Final', label: 'Final'}]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('phase')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('phase')">
                      {{ errors.first("phase") }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label">Phase type</label>
                    <el-select v-model="value.phase_type" v-validate="'required'" name="phase_type"
                               style="width: 100%" placeholder="select published phase_type">
                      <el-option
                        v-for="item in [
                           {value: 'Trial', label: 'Trial'},
                           {value: 'FixedTerm', label: 'FixedTerm'},
                           {value: 'Evergreen', label: 'Evergreen'}
                           ]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('phase_type')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('phase_type')">
                      {{ errors.first("phase_type") }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label">Phase period</label>
                    <el-select v-model="value.phase_period_conf" v-validate="'required'"
                               name="phase_period_conf"
                               placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in periods" :key="index"
                        v-bind:class="{'has-error': errors.has('phase_period_conf')}"
                        v-validate="'required'" :label="item" :value="index">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('phase_period_conf')">
                      {{ errors.first("phase_period_conf") }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label">Billing period</label>
                    <el-select v-model="value.billing_period_conf" v-validate="'required'"
                               name="billing_period_conf"
                               placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in periods" :key="index"
                        v-bind:class="{'has-error': errors.has('billing_period_conf')}"
                        v-validate="'required'" :label="item" :value="index">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('billing_period_conf')">
                      {{ errors.first("billing_period_conf") }}
                    </div>
                  </div>

                  <!--<div class="form-group col-6">
                    <label class="control-label">Upgradable Subscription Plan</label>
                    <el-select v-model="value.upgrade_plan_id"
                               name="upgrade_plan_id"
                               placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in allSubscriptionPlans" :key="index"
                        v-bind:class="{'has-error': errors.has('upgrade_plan_id')}"
                        :label="item" :value="index">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('upgrade_plan_id')">
                      {{ errors.first("upgrade_plan_id") }}
                    </div>
                  </div>

                  <div class="form-group col-6">
                    <label class="control-label">Downgradable Subscription Plan</label>
                    <el-select v-model="value.downgrade_plan_id" name="downgrade_plan_id"
                               placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in allSubscriptionPlans" :key="index"
                        v-bind:class="{'has-error': errors.has('downgrade_plan_id')}"
                        :label="item" :value="index">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('downgrade_plan_id')">
                      {{ errors.first("downgrade_plan_id") }}
                    </div>
                  </div>-->

                  <div class="form-group col-6">
                    <label class="control-label">Pre-Renew Notify Date Conf</label>
                    <el-select v-model="value.invoice_notify_conf.pre_renew_notify_date_conf"
                               name="pre_renew_notify_date_conf"
                               placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in notifyPeriods" :key="index"
                        v-bind:class="{'has-error': errors.has('pre_renew_notify_date_conf')}"
                        v-validate="'required'" :label="item" :value="index">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('pre_renew_notify_date_conf')">
                      {{ errors.first("pre_renew_notify_date_conf") }}
                    </div>
                  </div>

                  <div class="form-group col-6">
                    <label class="control-label" for="pre_renew_notify_url">Pre-Renw Notify URL</label>
                    <input type="text" id="pre_renew_notify_url" name="pre_renew_notify_url"
                           v-bind:class="{'has-error' : errors.has('pre_renew_notify_url')}"
                           v-model="value.invoice_notify_conf.pre_renew_notify_url" class="form-control pre_renew_notify_url"
                           placeholder="pre_renew_notify_url">
                    <div class="help text-danger" v-show="errors.has('pre_renew_notify_url')">
                      {{ errors.first("pre_renew_notify_url") }}
                    </div>
                  </div>

                  <div class="form-group col-6">
                    <label class="control-label" for="post_renew_notify_url">Post-Renew Notify URL</label>
                    <input type="text" id="post_renew_notify_url" name="post_renew_notify_url"
                           v-bind:class="{'has-error' : errors.has('post_renew_notify_url')}"
                           v-model="value.invoice_notify_conf.post_renew_notify_url" class="form-control post_renew_notify_url"
                           placeholder="post_renew_notify_url">
                    <div class="help text-danger" v-show="errors.has('post_renew_notify_url')">
                      {{ errors.first("post_renew_notify_url") }}
                    </div>
                  </div>

                  <div class="form-group col-6">
                    <label class="control-label" for="post_renew_notify_message">Post-Renew Notify Message</label>
                    <input type="text" id="post_renew_notify_message" name="post_renew_notify_message"
                           v-bind:class="{'has-error' : errors.has('post_renew_notify_message')}"
                           v-model="value.invoice_notify_conf.post_renew_notify_message" class="form-control post_renew_notify_message"
                           placeholder="post_renew_notify_message">
                    <div class="help text-danger" v-show="errors.has('post_renew_notify_message')">
                      {{ errors.first("post_renew_notify_message") }}
                    </div>
                  </div>

                  <!--<div class="form-group col-6">
                    <label class="control-label" for="callback_url">Callback URL</label>
                    <input type="text" id="callback_url" name="callback_url"
                           v-bind:class="{'has-error' : errors.has('callback_url')}"
                           v-model="value.callback_url" class="form-control callback_url"
                           placeholder="callback_url">
                    <div class="help text-danger" v-show="errors.has('callback_url')">
                      {{ errors.first("callback_url") }}
                    </div>
                  </div>-->

                  <div class="form-group col-6 required">
                    <label class="control-label">App-id</label>
                    <el-select v-model="value.app_id" v-validate="'required'"
                               name="app_id" placeholder="Select" style="width: 100%">
                      <el-option
                        v-for="(item, index) in allApplications" :key="item.app_id"
                        v-bind:class="{'has-error': errors.has('app_id')}"
                        v-validate="'required'" :label="item.name" :value="item.app_id">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('app_id')">
                      {{ errors.first("app_id") }}
                    </div>
                  </div>

                  <div class="form-group col-6 required">
                    <label class="control-label">Status</label>
                    <el-select v-model="value.status" v-validate="'required'" name="status"
                               style="width: 100%" placeholder="select published status">
                      <el-option
                        v-for="item in [{value: 1, label: 'Active'}, {value: 0, label: 'Inactive'}]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('status')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import {mapGetters} from 'vuex';
import {CBSSubscriptionApi, CBSCommonApi} from '@/services/api';

const periods = {
  1: "Daily",
  2: "Weekly",
  3: "Bi-Weekly",
  4: "Monthly",
  5: "Quarterly",
  6: "Yearly",
  /*'7': "Custom"*/
}

const notifyPeriods = {
  '{"day": -1, "min": 1, "type": "INTERVAL_TIME_FIXED"}': "Day before renewal"
}

export default {
  name: 'SubscriptionPlanForm',
  components: {},
  computed: {
    ...mapGetters(['profile'])
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {
      type: 'Product',
      status: 1,
      invoice_notify_conf: {},
      product_property: [],
      product_association: [],
    },
    allApplications: [],
    allProductCategory: [],
    allProducts: [],
    allUniqueRefIds: [],
    allSubscriptionPlans: [],
    periods: periods,
    notifyPeriods: notifyPeriods,
  }),
  methods: {
    handleSubmission() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.is_loading = true;
          if (this.is_edit) {
            this.value.updated_by = this.profile.id
            CBSSubscriptionApi.updatePlan(this.params.id, this.value)
              .then((response) => {
                this.$router.push({name: 'SubscriptionPlanList'})
                this.$toaster.success(response.message)
              })
              .catch((error) => {
                this.$toaster.error(error.response.data.message)
                this.$setErrorsFromResponse(error.response.data)
              }).finally(() => {
              this.is_loading = false
            })
          } else {
            this.value.organization_ref_id = this.profile.organization_ref_id
            this.value.user_ref_id = this.profile.user_ref_id
            this.value.role_ref_id = this.profile.role_ref_id
            this.value.created_by = this.profile.id

            CBSSubscriptionApi.storePlan(this.value)
              .then((response) => {
                this.$toaster.success(response.message);
                this.$router.push({name: 'SubscriptionPlanList'});
              })
              .catch((error) => {
                this.$toaster.error(error.response.data.message)
                this.$setErrorsFromResponse(error.response.data)
              }).finally(() => {
              this.is_loading = false
            })
          }
        }
      })
    },

    getDetail: function (id) {
      CBSSubscriptionApi.showPlan(id)
        .then((item) => {
          this.value = item
          this.value.app_id = parseInt(this.value.app_id)
          this.value.product_id = parseInt(this.value.product_id)
          this.value.phase_period_conf = this.value.phase_period_conf.toString()
          this.value.billing_period_conf = this.value.billing_period_conf.toString()
        })
        .catch((error) => {
          this.$toaster.error(error.response.data.message)
        })
        .finally(() => {
          this.is_loading = false
        })
    },

    getApplications: function () {
      CBSCommonApi.getAllApplications().then((response) => {
        this.allApplications = response
      })
    },

    getProducts: function () {
      CBSCommonApi.getAllProducts('Package').then((response) => {
        this.allProducts = response
      })
    },

    getUniqueRefIds: function () {
      CBSSubscriptionApi.getUniqueRefIds().then((response) => {
        this.allUniqueRefIds = response
      })
    },

    getSubscriptionPlans: function () {
      CBSSubscriptionApi.getSubscriptionPlans().then((response) => {
        this.allSubscriptionPlans = response
      })
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      await this.getApplications()
      await this.getProducts()
      await this.getUniqueRefIds()
      await this.getSubscriptionPlans()

      if (this.is_edit) {
        await this.getDetail(this.params.id)
      }
      this.is_loading = false
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>
